var _style, _ellipse, _line, _line2, _line3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricalClockControl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 5.2,
    cy: 8,
    rx: 4.6,
    ry: 4.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.8,
    y1: 8,
    x2: 11.1,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.1,
    y1: 8,
    x2: 13.4,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.3,
    y1: 8,
    x2: 15.6,
    y2: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,8c0.1,0,2.9,0,2.9,0V4.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalClockControl);
export default __webpack_public_path__ + "static/media/ElectricalClockControl.19d1a1b5b17687e4ada2cda311fbcd6e.svg";
export { ForwardRef as ReactComponent };